import PortalClienteService from "services/bases/PortalClienteService";

class PerfisDeAcessoService extends PortalClienteService{
    async ListarTiposPerfisDeAcessoAoDireito(formularioId = null){
        return await this.get(`perfisdeacesso/TiposPerfisDeAcessoAoDireito?formularioId=${formularioId}`)
    }
    async ListarPerfisDeAcessoAoDireitoPorContato(contatoId, status){
        return await this.get(`perfisdeacesso/ListarPerfisDeAcessoPorContato?contatoId=${contatoId}&status=${status}`)
    }
}

export default new PerfisDeAcessoService();